import { TextField } from "@material-ui/core";
import React from "react";
import { useController } from "react-hook-form";

const InputField = ({ name, label, control, ...inputProps }) => {
  const {
    fieldState: { invalid, error, value },
    field: { onBlur, onChange, ref },
  } = useController({
    name,
    control,
  });
  return (
    <TextField
      value={value}
      name={name}
      label={label}
      inputRef={ref}
      onChange={onChange}
      onBlur={onBlur}
      helperText={error?.message}
      variant="outlined"
      fullWidth
      margin="normal"
      error={invalid}
      inputProps={inputProps}
    />
  );
};

export default InputField;
